import { lazy, Suspense, useContext } from "react";
import { appDataContext } from "@/context";
import { Helmet } from "react-helmet-async";
import styled from "styled-components";

const Articles = lazy(() => import("@/components/Articles"));
//import Articles from '@/components/Articles';
const ArticlesPageLayout = lazy(() => import("@/layouts/ArticlesPageLayout"));
//import ArticlesPageLayout from "@/layouts/ArticlesPageLayout";

const ArticlesPage = () => {
  const dataContext = useContext(appDataContext);

  const text = dataContext?.lang;
  const routeMap = dataContext?.routeMap;

  return (
    <Suspense>
      <ArticlesPageLayout>
        <Helmet>
          <title>{` ${text?.home?.articles.backtitle} - ${text?.site.title}`}</title>
        </Helmet>
        <Title>{text?.home?.articles.backtitle}</Title>
        <Suspense>
          <Articles text={text} routeMap={routeMap} $columns />
        </Suspense>
      </ArticlesPageLayout>
    </Suspense>
  );
};

export default ArticlesPage;

const Title = styled.h1`
  transition: all 0.2s ease-in-out;
  text-align: center;
  font-size: 2rem;
  margin-bottom: 16px;
  @media screen and (min-width: 768px) {
    font-size: 3.2rem;
    margin-bottom: 32px;
  }
  span {
    display: block;
    font-size: 1.4rem;
    font-weight: 400;
    @media screen and (min-width: 768px) {
      font-size: 1.6rem;
    }
  }
`;
